import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import LinkwithModal from '../LinkWithModal';
import Button from '@mui/material/Button';
import { DEFAULT_PRIMARY_FONT_FAMILY } from 'theme/fontDefaults';

export const StPrimaryLinks = styled(LinkwithModal, {
  shouldForwardProp: (prop) => prop !== 'linkFontColor',
})<{ linkFontColor?: string }>(({ theme, linkFontColor }) => ({
  fontFamily: theme?.palette?.primaryFontFamilyType
    ? `${theme?.palette?.primaryFontFamilyType} Bold, sans-serif`
    : `${DEFAULT_PRIMARY_FONT_FAMILY}, sans-serif`,
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  textAlign: 'center',
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
  marginRight: '1.5rem',
  marginBottom: '1rem',
  textDecoration: 'none',
  color: linkFontColor ? linkFontColor : theme.palette.white.main,
  '&:hover': {
    textDecoration: 'none',
    borderBottom: '1px dashed',
    color: linkFontColor ? linkFontColor : theme.palette.white.main,
  },
  [theme.breakpoints.down('sm')]: {
    marginRight: 0,
  },
}));

export const StPrimaryDefaultLinks = styled(LinkwithModal, {
  shouldForwardProp: (prop) => prop !== 'linkFontColor',
})<{ linkFontColor?: string; isDefaultApp?: boolean }>(
  ({ theme, linkFontColor, isDefaultApp }) => ({
    fontFamily: theme?.palette?.primaryFontFamilyType
      ? `${theme?.palette?.primaryFontFamilyType} Bold, sans-serif`
      : `${DEFAULT_PRIMARY_FONT_FAMILY}, sans-serif`,
    fontStyle: 'normal',
    fontWeight: isDefaultApp ? 700 : 600,
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'center',
    letterSpacing: isDefaultApp ? '0.32px' : '0.5px',
    textTransform: 'uppercase',
    marginRight: isDefaultApp ? '1rem' : '1.5rem',
    marginBottom: '1rem',
    textDecoration: 'none',
    color: linkFontColor ? linkFontColor : theme.palette.white.main,
    '&:hover': {
      textDecoration: 'none',
      borderBottom: '1px dashed',
      color: linkFontColor ? linkFontColor : theme.palette.white.main,
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  })
);

export const AppBarButton = styled(Button)<{ isDefaultApp?: boolean }>(
  ({ theme, isDefaultApp }) => ({
    fontFamily: theme?.palette?.primaryFontFamilyType
      ? `${theme?.palette?.primaryFontFamilyType} Bold, sans-serif`
      : `${DEFAULT_PRIMARY_FONT_FAMILY}, sans-serif`,
    fontStyle: 'normal',
    fontWeight: isDefaultApp ? 700 : 600,
    fontSize: '16px',
    textAlign: 'center',
    letterSpacing: '0.32px',
    textTransform: 'uppercase',
    marginRight: '1.5rem',
    marginBottom: '1rem',
    textDecoration: 'none',
    color: (theme.palette as any).fontTextColor1.main || theme.palette.white.main,
    margin: 0,
    padding: 0,
    lineHeight: 'normal !important',
    '&:hover': {
      textDecoration: 'none',
      borderBottom: '1px dashed',
      color: (theme.palette as any).fontTextColor1.main || theme.palette.white.main,
      borderRadius: 0,
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  })
);

export const StPrimaryLinkItem = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    marginBottom: '1rem',
    '&:last-child': {
      marginBottom: '0rem',
    },
  },
}));
